import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  WebGameColumn,
  WebGameMainCont,
  ConnectionPopupsWr,
  WebGameColumnInner,
  userSettingsStore,
} from '@pascal/pascal-core';

import { GameMain } from '../../game';
import { PopupsWrapper } from '../common';
import RightColumn from '../common/rightColumn';
import fastTradeLogoDark from '../../assets/images/game/fastTradeLogo-dark.png';
import fastTradeLogoLight from '../../assets/images/game/fastTradeLogo-light.png';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';

export const WebMainWrapper = observer(() => {
  return (
    <WebGameMainCont
      isShowIconTag
      hasDemoPopup
      isShowBogLineLobby
      playForRealPopupImgSrc={playForRealPopupImgSrc}
      lobbyLogoImageSrc={userSettingsStore.isDarkModeOn ? fastTradeLogoDark : fastTradeLogoLight}
    >
      <WebGameColumn position='center'>
        <WebGameColumnInner position='center'>
          <GameMain />
        </WebGameColumnInner>
        <PopupsWrapper />
      </WebGameColumn>
      <RightColumn />
      <ConnectionPopupsWr />
    </WebGameMainCont>
  );
});
